// ═══════════════════════════════════════════════════════════════════════════
// PAGE ADMIN RISKLISTS — barre d'affectation de phases en masse (câblage)
// Extrait de page-admin-risklists.ts (`renderRiskListDetail` à 242 lignes, à
// 8 du cliquet taille-fonction, 2026-09-27) : tout sélectionner, compteur de
// la barre, Appliquer et Annuler. Le markup (`#bulk-bar`, cases de phases)
// reste dans la page, avec `buildStageCheckboxes`. Comportement identique à
// l'inline.
// ═══════════════════════════════════════════════════════════════════════════
//
// Bare refs utilisées (résolues via core-globals.d.ts) : api, t, toast.

interface BulkAssignResult {
  updated: number;
}

/**
 * Câble la barre d'affectation en masse du détail d'une liste de risques.
 *
 * `onApplied` est joué après une affectation réussie (la page se recharge).
 * À appeler une fois la table et la barre montées dans le DOM.
 */
export function wireBulkStageBar(lid: number, onApplied: () => void): void {
  const selAll = document.getElementById('chk-select-all-std') as HTMLInputElement | null;
  if (selAll) {
    selAll.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLInputElement | null;
      if (!target) return;
      document.querySelectorAll<HTMLInputElement>('.std-risk-chk').forEach((c) => {
        c.checked = target.checked;
      });
      updateBulkBar();
    });
  }

  const container = document.getElementById('std-risks-container');
  if (container) {
    container.addEventListener('change', (e: Event) => {
      const target = e.target as HTMLElement | null;
      if (target?.classList.contains('std-risk-chk')) updateBulkBar();
    });
  }

  function updateBulkBar(): void {
    const checked = document.querySelectorAll('.std-risk-chk:checked');
    const bar = document.getElementById('bulk-bar');
    const countEl = document.getElementById('bulk-count');
    if (bar) bar.style.display = checked.length ? '' : 'none';
    if (countEl) countEl.textContent = t('risk_lists.bulk.count', { n: checked.length });
  }

  const btnBulkApply = document.getElementById('btn-bulk-apply');
  if (btnBulkApply) {
    btnBulkApply.addEventListener('click', () => {
      void (async () => {
        const selectedIds = [
          ...document.querySelectorAll<HTMLInputElement>('.std-risk-chk:checked'),
        ].map((c) => parseInt(c.dataset['rid'] || '0'));
        const selectedStages = [
          ...document.querySelectorAll<HTMLInputElement>('.bulk-stage-chk:checked'),
        ].map((c) => c.value);
        if (!selectedIds.length) {
          toast(t('risk_lists.bulk.error.no_risk'), 'error');
          return;
        }
        if (!selectedStages.length) {
          toast(t('risk_lists.bulk.error.no_stage'), 'error');
          return;
        }
        try {
          const result = (await api.bulkAssignStages(lid, {
            risk_ids: selectedIds,
            stages: selectedStages,
          })) as BulkAssignResult;
          toast(t('risk_lists.bulk.toast.updated', { n: result.updated }));
          onApplied();
        } catch (err: unknown) {
          const msg = err instanceof Error ? err.message : t('common.error');
          toast(msg, 'error');
        }
      })();
    });
  }

  const btnBulkCancel = document.getElementById('btn-bulk-cancel');
  if (btnBulkCancel) {
    btnBulkCancel.addEventListener('click', () => {
      document.querySelectorAll<HTMLInputElement>('.std-risk-chk').forEach((c) => {
        c.checked = false;
      });
      if (selAll) selAll.checked = false;
      updateBulkBar();
    });
  }
}
